module.exports = __webpack_public_path__ + "img/banner4.7d690ae1.7d690ae1.jpg";